import fetch from 'isomorphic-fetch';
import { config } from '../config/config';
import store from '../redux/store';

/** `/client/:client_id` and `/fleet/:client_id` take the signed-in organisation; the backend reads it from the token. */
export const clientId = (): string => store.getState().me.me.organization?.id;

/**
 * Calls the loop-pro backend with the session token. Answers the parsed body (undefined when empty) and throws the
 * backend's message on any non-2xx, joining class-validator's message arrays.
 */
export const lpRequest = async (
  path: string,
  init: { method?: string; body?: any } = {}
): Promise<any> => {
  const token = store.getState().token.token;
  const isForm = init.body instanceof FormData;

  const headers = new Headers({ Authorization: `Bearer ${token}` });
  if (init.body !== undefined && !isForm) headers.set('Content-Type', 'application/json');

  const response = await fetch(`${config.uri.loop_pro_api}/api${path}`, {
    method: init.method || 'GET',
    headers,
    body: init.body === undefined || isForm ? init.body : JSON.stringify(init.body)
  });

  const text = await response.text();
  const result = text ? JSON.parse(text) : undefined;

  if (!response.ok) {
    const message = result?.message;
    const error: any = new Error(
      (Array.isArray(message) ? message.join(', ') : message) || 'Something went wrong'
    );
    error.status = response.status;
    throw error;
  }

  return result;
};
